import React, { useState } from 'react';
import { DataBox } from "./DataBox";
import { KeyWordsTypeDrawer } from "./keyWordsTypeDrawer";
import { KeyWordsDrawer } from "./keyWordsDrawer";
import { Spin } from 'antd';
import { useKeyWordsModel } from '../keyWordsModel';

export function KeyWords() {
    const {
        loading
    } = useKeyWordsModel();
    return (
        <Spin tip="列表加载中" spinning={loading}>
            <DataBox />
            <KeyWordsTypeDrawer />
            <KeyWordsDrawer />
        </Spin>
    )
}

